module.exports = __webpack_public_path__ + "img/360-konferensrum-2.bc8a7695.jpg";